export default "__VITE_ASSET__BkbaWaAs__"